import { useMemo } from 'react';

import { useQuery } from '@apollo/client/react';

import { ACCOUNT_COUNTRIES } from './graphql';

/**
 * Country IDs that at least one account belongs to, for narrowing an account
 * selector. Deliberately not the full ISO list — offering a country with no
 * accounts behind it only produces an empty result.
 */
export const useAccountCountries = () => {
  const { data, loading } = useQuery(ACCOUNT_COUNTRIES);

  const countries = useMemo(
    () => (data?.MdCountriesUsedByAccounts ?? []).map(({ id }) => id),
    [data]
  );

  return { countries, loading };
};
